// removed by extract-text-webpack-plugin
module.exports = {"container":"_2LW0h","logo":"_3wLAa","text":"dUlfG"};


//////////////////
// WEBPACK FOOTER
// ../source/components/BreakitBanner/styles.css
// module id = 1636
// module chunks = 10